import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ImageDrawModal from './canvas/ImageDrawModal';
import ImageDrawCard from './canvas/ImageDrawCard';

function EyeDrawSection({ id, title, icon, cards }) {
    const [show, setShow] = useState(false);
    const [drawTitle, setDrawTitle] = useState('');
    const [showImage, setShowImage] = useState(null);

    const handleShow = (subtitle, image) => {
        setDrawTitle(subtitle);
        setShowImage(image);
        setShow(true);
    };

    return (
        <section id={id} className="eye-draw-section mb-4">
            <div className="ecx-page-card">
                <div className="ecx-page-panel__header">
                    <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap">
                        <div className="d-flex align-items-center gap-2 min-width-0">
                            <span className="ecx-page-icon-badge eye-draw-section__icon">
                                <i className={`bi ${icon}`}></i>
                            </span>
                            <h6 className="mb-0 fw-semibold text-truncate">{title}</h6>
                        </div>
                        <span className="ecx-page-chip flex-shrink-0">
                            <i className="bi bi-images"></i>
                            {cards.length} template{cards.length === 1 ? '' : 's'}
                        </span>
                    </div>
                </div>
                <div className="ecx-page-panel__body">
                    <div className="row g-3 row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-lg-5 row-cols-xl-6">
                        {cards.map((card) => (
                            <ImageDrawCard
                                key={card.title}
                                title={card.title}
                                thumb={card.thumb}
                                image={card.image}
                                onClick={handleShow}
                            />
                        ))}
                    </div>
                </div>
            </div>

            {showImage && (
                <ImageDrawModal
                    show={show}
                    title={drawTitle}
                    image={showImage}
                    onClose={() => setShow(false)}
                />
            )}
        </section>
    );
}

EyeDrawSection.propTypes = {
    id: PropTypes.string,
    title: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    cards: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            thumb: PropTypes.string.isRequired,
            image: PropTypes.any.isRequired,
        })
    ).isRequired,
};

export default EyeDrawSection;
